import { FetchActivityCountersPayload } from "PFCore/services/workflow_inbox/activity_counters";

export const activityCountersKeys = {
  all: () => ["activityCounters"],
  list: (params: FetchActivityCountersPayload) => [...activityCountersKeys.all(), params.templateKey]
};
